<template>
  <div v-if="currentAd && isLoggedIn && !isAdmin && !isSuperAdmin" class="ad-slot" :class="{ 'ad-slot--minimized': adMinimized }">
    <button
      v-if="adMinimized"
      class="show-ad-button"
      type="button"
      :aria-label="$t('Show Offer')"
      @click="expandAd"
    >
      {{ $t('Show Offer') }}
    </button>
    <div
      v-else
      class="ad-content"
      role="region"
      :aria-label="$t('Offers')"
      @keydown.left.prevent="previousAd"
      @keydown.right.prevent="nextAd"
    >
      <div class="ad-controls">
        <button
          class="ad-control-button"
          type="button"
          :aria-label="$t('Minimize ad')"
          @click="minimizeAd"
        >
          −
        </button>
        <button
          class="ad-control-button"
          type="button"
          :aria-label="$t('Close ad')"
          @click="dismissAd"
        >
          ×
        </button>
      </div>
      <a :href="currentAd.link" target="_blank" rel="noopener noreferrer" @click="trackAdClick">
        <img :key="currentAd.id" :src="sizedAdImage(currentAd.image)" :alt="currentAd.name" class="ad-image" />
      </a>
      <div v-if="ads.length > 1" class="ad-navigation">
        <button type="button" class="ad-control-button ad-navigation-button" :aria-label="$t('Previous ad')" @click="previousAd">
          <svgicon name="chevron" class="ad-navigation-icon ad-navigation-icon--previous" aria-hidden="true" />
        </button>
        <span class="ad-position" aria-live="polite" aria-atomic="true">
          {{ $t('Ad %(current)% of %(total)%', { current: activeIndex + 1, total: ads.length }) }}
        </span>
        <button type="button" class="ad-control-button ad-navigation-button" :aria-label="$t('Next ad')" @click="nextAd">
          <svgicon name="chevron" class="ad-navigation-icon ad-navigation-icon--next" aria-hidden="true" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import { ProfileActions } from '@/store/modules/user/profile/types';
import { RootActions, EventTypes } from '@/store/types';
import imageSizeMixin from '@/components/mixins/image-size';

export default imageSizeMixin.extend({
  name: 'AdSlot',
  data() {
    return { activeIndex: 0 };
  },
  computed: {
    ...mapState('user/profile', ['ads', 'adMinimized']),
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('user/profile', ['isLoaded', 'isAdmin', 'isSuperAdmin']),
    currentAd() {
      return this.ads[this.activeIndex];
    }
  },
  methods: {
    ...mapActions('user/profile', {
      fetchAds: ProfileActions.FETCH_ADS,
      dismissAd: ProfileActions.DISMISS_AD,
      minimizeAd: ProfileActions.MINIMIZE_AD,
      expandAd: ProfileActions.EXPAND_AD
    }),
    ...mapActions([RootActions.DISPATCH_EVENT]),
    previousAd() {
      if (this.ads.length > 1) {
        this.activeIndex = (this.activeIndex + this.ads.length - 1) % this.ads.length;
      }
    },
    nextAd() {
      if (this.ads.length > 1) {
        this.activeIndex = (this.activeIndex + 1) % this.ads.length;
      }
    },
    trackAdClick() {
      this[RootActions.DISPATCH_EVENT]({
        type: EventTypes.AD_CLICK,
        eventObj: { ad_url: this.currentAd.link }
      });
    }
  },
  watch: {
    ads() {
      this.activeIndex = 0;
    },
    isLoaded: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.fetchAds();
        }
      }
    },
  }
});
</script>
